import styled from 'styled-components';
import { device } from '@/styles/helpers';

export const ScVipTransferCardFactory = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${({ theme }) => theme.grayLightColor};
  border-radius: 24px;
  padding: 24px;
  width: 100%;
  max-width: 536px;

  @media (${device.mobile}) {
    max-width: none;
  }
`;
